export default {
  namespaced: true,
  state: {
    isHamburgerMenuOpen: false,
    isModalOpen: false,
    isTouch: false,
    isDark: false,
  },
  mutations: {
    toggleHamburgerMenu(state) {
      state.isHamburgerMenuOpen = !state.isHamburgerMenuOpen;
    },
    setModalState(state, isOpen) {
      state.isModalOpen = isOpen;
    },
    setHamburgerMenuOpen(state, status) {
      state.isHamburgerMenuOpen = status;
    },
    setIstouch(state, isTouch) {
      state.istouch = isTouch;
    },
    closeHamburgerMenu(state) {
      state.isHamburgerMenuOpen = false;
    },
    toggleDark(state) {
      state.isDark = !state.isDark;
    }
  },
  actions: {
    openModal({ commit }) {
      commit("setModalState", true);
    },
    closeModal({ commit }) {
      commit("setModalState", false);
    },
  },
  getters: {
    isModalOpen: (state) => state.isModalOpen,
  },
};
